<template>
  <div class="content">
    <div class="contentPrincipal">
      <div class="myContent">
      <div class="tabContent">
        <div class="tabElement commande active" @click="changeTab('commande')">
          <span class="material-icons-sharp"> shopping_cart </span>Bon de commande en attente de paiement
        </div>
        <div class="tabElement commandeWait" @click="changeTab('commandeWait')">
          <span class="material-icons-sharp"> app_registration </span>Bon de commande
        </div>
      </div>
</div>
      <div id="commandeTab" class="tabElementContent active">
        <div @click="addNewCustomerCommande" class="buttonAdd">
          <span> Ajouter un bon de commande</span>
        </div>
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <img v-if="card.length == 0" src="../assets/empty2.png" alt="" />
            <tbody v-else>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in card"
                :key="item._id"
              >
                <td>
                  <div class="nameContentButton">
                    <div
                      @click="showCartDetails(item)"
                      class="buttonAddSecond"
                    >
                      <span> Voir article</span>
                    </div>
                  </div>
                </td>
                <td @click="editeCustomerCommandeRow(item)">
                  {{ item.number }}
                </td>
                <td @click="editeCustomerCommandeRow(item)">
                  {{ item.status }}
                </td>
                <td @click="editeCustomerCommandeRow(item)">
                  {{ item.customer ? item.customer.name : "" }}
                </td>
                <td @click="editeCustomerCommandeRow(item)">
                  {{ item.totalCartDetail }}
                </td>
                <td @click="editeCustomerCommandeRow(item)">
                  {{ item.amount }}
                </td>
                <!-- <td @click="editeCustomerCommandeRow(item)">
                  {{ item.reduction }}
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="commandeWaitTab" class="tabElementContent">
        <div class="contentLists">
          <table class="contentListeTable">
            <thead>
              <tr>
                <th v-for="item in tableHeader" :key="item">{{ item }}</th>
              </tr>
            </thead>
            <img v-if="card.length == 0" src="../assets/empty2.png" alt="" />
            <tbody v-else>
              <tr
                :class="item.isSelected === true ? 'active' : 'noActive'"
                v-for="item in card"
                :key="item._id"
              >
                <td>
                  <div class="nameContentButton">
                    <div
                      @click="showCartDetails(item)"
                      class="buttonAddSecond"
                    >
                      <span> Voir article</span>
                    </div>
                  </div>
                </td>
       
                <td>
                  {{ item.number }}
                </td>
                <td>
                  {{ item.status }}
                </td>
                <td>
                  {{ item.customer ? item.customer.name : "" }}
                </td>
                <td >
                  {{ item.totalCartDetail }}
                </td>
                <td >
                  {{ item.amount }}
                </td>
                <!-- <td >
                  {{ item.reduction }}
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "customerCommande",
  components: {},
  data: () => ({
    tableHeader: [
      "",
      "Numéro de Commande",
      "Statut",
      "Clients",
      "Nombre d'articles",
      "Montant Total",
    ],
    tableHeaderWait: [
      "",
      "Statut",
      "Numéro de Commande",
      "Clients",
      "Nombre d'articles",
      "Montant Total",
    ],
    isSelecteds: [],
    isSelectedAll: false,
    tableHeaderBl: [
      "Contrat",
      "Numéro BL",
      "Nbr de conteneur",
      "Port de chargement",
      "Navire",
      "Ligne",
      "Destination",
      "Etdpol",
      "Eta",
      "Observation",
    ],
    tableHeaderConteneur: [
      "Commande",
      "Désignation",
      "Type de conteneur",
      "Numéro BL",
      "Produit",
      "Magasin",
      "Date de sourti",
      "Transitaire",
      "Montant Transitaire",
      "Montant total",
      "Observation",
    ],
    tableHeaderConteneurNone: [
      "",
      "Commande",
      "Désignation",
      "Type de conteneur",
      "Numéro BL",
      "Produit",
      "Transitaire",
      "Montant Transitaire",
      "Montant total",
      "Observation",
    ],
  }),
  watch: {
    contenuerAllData() {
      this.isSelecteds = [];
    },
  },
  computed: {
    ...mapGetters([
      "contratData",
      "blData",
      "conteneurData",
      "contenuerAllData",
      "storeData",
      "card",
    ]),
  },
  async mounted() {
    await this.getCard({ status: "Attente",alreadyExpired: false });
  },
  methods: {
    ...mapActions([
      "getCustomerList",
      "getProduct",
      "getContrat",
      "getStore",
      "getCard",
      "getCardDetails"
    ]),
    raccourcirTexte(texte) {
      return texte;
    },

    async addNewCustomerCommande() {
      this.$emit("show",true)
      await this.getCustomerList({});
      await this.getProduct({});
      await this.getStore({});
      
      const value = {
        modalType: "customerCommande",
        amount:0,
        observation:'Néant'
      };
      //   alert(item);
      this.$emit("editeRowForDash", {
        name: "customerCommande",
        size: 300,
        value: value,
      });
      this.$emit("show",false)
    },

    async editeCustomerCommandeRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.card.length; i++) {
          this.card[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.card);
        await this.getCustomerList({});
        await this.getProduct({});
        await this.getStore({});
        const value = {
          _id: item._id,
          modalType: "customerCommande",
          reduction: item.reduction,
          observation: item.observation,
          customer: item.customer.name,
          amount: item.amount,
          // expiredAt: item.expiredAt
        };
        this.$emit("editeRowForDash", {
          name: "customerCommande",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      } 
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
     
    },
    async showCartDetails(item) {
      this.$emit("show",true)
  
        for (let i = 0; i < this.card.length; i++) {
          this.card[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.card);
        this.getCardDetails({cart: item._id})
        const value = {
          _id: item._id,
          modalType: "showCartDetails",
          reduction: item.reduction,
          observation: item.observation,
          sentToCashRegisterBy: item.sentToCashRegisterBy ? item.sentToCashRegisterBy :'',
          customer: item.customer.name,
          amount: item.amount,
          status: item.status,
          expiredAt: item.expiredAt,
        };
        this.$emit("editeRowForDash", {
          name: "showCartDetails",
          size: 1000,
          value: value,
        });
    
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async editeConteneurRow(item) {
      this.$emit("show",true)
      if (!item.isSelected) {
        for (let i = 0; i < this.contenuerAllData.length; i++) {
          this.contenuerAllData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log("OK", item);
        await this.getConteneur();
        await this.getContratDetails({});
        await this.getBl({});
        await this.getTransitaire();

        const value = {
          _id: item._id,
          modalType: "conteneurPrincipaleAll",
          observation: item.observation,
          containType: item.containType ? item.containType.name : "",
          store: item.store ? item.store.name : "",
          contractDetail: item.contractDetail ? item.contractDetail.number : "",
          name: item.name,
          bl: item.bl ? item.bl.number : "",
          product: item.product ? item.product.name : "",
          outDate: item.outDate,
          transitaire: item.transitaire ? item.transitaire.fullName : "",
          transitaireAmount: item.transitaireAmount,
          amount: item.amount,
        };
        this.$emit("editeRowForDash", {
          name: "conteneurPrincipaleAll",
          size: 300,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    async addNewContratDetails(item) {
      this.$emit("show",true)

      if (!item.isSelected) {
        for (let i = 0; i < this.contratData.length; i++) {
          this.contratData[i].isSelected = false;
        }
        item.isSelected = true;
        console.log(this.contratData);
        const value = {
          _id: item._id,
          modalType: "commande",
          number: item.number,
          supplier: item.supplier.fullName,
          observation: item.observation,
        };
        await this.getContratDetails({ contract: item._id });
        this.$emit("editeRowForDash", {
          name: "commande",
          size: 1000,
          value: value,
        });
      } else {
        item.isSelected = false;
        this.$emit("closeAllModal");
      }
      this.$emit("show",false)
      // Forcer la mise à jour de la vue après modification de isSelected
      this.$forceUpdate();
    },
    //     makeSelectAll() {

    //   if (!this.isSelectedAll) {
    //     this.isSelectedAll = true;

    //     this.contenuerAllData.forEach((resourceItem) => {
    //       resourceItem.isSelected = true;
    //       this.isSelected.push(resourceItem._id);
    //     });

    //   } else {
    //     this.isSelectedAll = false;

    //     this.contenuerAllData.forEach((resourceItem) => {

    //       const index = this.isSelected.indexOf(resourceItem._id);
    //       resourceItem.isSelected = false;
    //       if (index !== -1) {
    //         this.isSelected.splice(index, 1);
    //       }
    //     });
    //   }
    // },
    makeSelect(item) {
      if (!item.isSelected) {
        item.isSelected = true; // Met item.isSelected à true

        this.isSelecteds.push(item._id);
      } else {
        item.isSelected = false;

        const index = this.isSelecteds.indexOf(item._id);
        if (index !== -1) {
          this.isSelecteds.splice(index, 1);
        }
      }
      // alert(JSON.stringify(this.selectedItemsIds));
    },
    async changeTab(tabName) {
      this.$emit("closeAllModal");
      if (tabName === "contrat") {
        await this.getContrat({});
      } else if (tabName === "bl") {
        await this.getBl({});
      } else if (tabName === "conteneur") {
        await this.getConteneurAll({ alreadyInStock: "Oui" });
      } else if (tabName === "conteneurWait") {
        await this.getConteneurAll({ alreadyInStock: "Non" });
      } else if (tabName === "commandeWait") {
        await this.getCard({ status: "", });
      }
      else if (tabName === "commande") {
        await this.getCard({ status: "Attente",alreadyExpired: false });
      }
      // Masquer tous les onglets
      var tabContents = document.querySelectorAll(".tabElementContent");
      tabContents.forEach(function (tabContent) {
        tabContent.classList.remove("active");
      });

      // Afficher l'onglet sélectionné
      var selectedTab = document.getElementById(tabName + "Tab");
      selectedTab.classList.add("active");

      // Mettre à jour l'état actif des onglets de la barre de navigation
      var tabElements = document.querySelectorAll(".tabElement");
      tabElements.forEach(function (tabElement) {
        tabElement.classList.remove("active");
      });

      var selectedTabElement = document.querySelector(".tabElement." + tabName);
      selectedTabElement.classList.add("active");
    },
  },
};
</script>
  